import '@/components/common/css/index/module.css';
import '@/components/common/css/index/online.css';
import Back from '@/components/public/back/Back.vue';
import api from '../../../common/libs/api.js';
import {getSign, phoneReg} from '../../../common/libs/common.js';
import {mapState} from 'vuex';
import CityCodeData from '@/common/libs/CityCodeData';
import Tail from '@/components/public/tail/Tail.vue';
import utils from '../../../common/libs/utils.js';

export default{
  name: 'OnlineOneToOne',
  components: {
    Back,
    Tail
  },
  data(){
    return {
      name: '',
      phone: '',
      title: '',
      namePlaceholder: '',
      phonePlaceholder: '',
      grades: [{}],
      grade: '',
      subjects: [{}],
      subject: '',
      active: 0,
      sms_code: '',
      phoneRight: false,
      sendCode: true,
      reSendCode: false,
      codeNum: 60,
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        }
      },
      isUse: false
    }
  },
  metaData({store, route}){
    var city = CityCodeData.getCityByShort(route.params.city);
    store.dispatch('setMeta', {
      title: `${city.city_name  }在线1对1_学而思爱智康在线一对一辅导_${city.city_name}学而思爱智康`,
      keywords: `${city.city_name  }在线1对1,在线一对一辅导,学而思爱智康在线1对1`,
      description: `${city.city_name  }学而思爱智康官网提供各学科在线1对1辅导，涵盖小学、初中、高中各年级的一对一在线课程，专业教师团队满足不同学生的个性化需求,学而思爱智康在线一对一咨询电话400-810-2680`
    });
  },
  computed: mapState({
    city: state => state.home.city,
    network: state => state.home.network,
    onlineSeoInfo: state => state.homeCourse.onlineSeoInfo
  }),
  asyncData({store, route}){
    let city = CityCodeData.getCityByShort(route.params.city);

    store.commit('setOnlineSeoInfo', {
      headImg: `${city.city_name + (city.brand||'学而思爱智康')}在线1对1`,
      middleFirstImg: `${city.city_name + (city.brand||'学而思爱智康') }在线1对1课程`,
      middleSecondImg: `${city.city_name + (city.brand||'学而思爱智康')}在线1对1学习方案`,
      middleThirdImg: `${city.city_name + (city.brand||'学而思爱智康')}在线1对1直播教学`,
      personFirstImg: `${city.city_name + (city.brand||'学而思爱智康')}老师`,
      personSecondImg: `${city.city_name + (city.brand||'学而思爱智康')}老师`,
      personThirdImg: `${city.city_name + (city.brand||'学而思爱智康')}老师李振涛`
    });
  },
  methods: {
    play(){
      let stater = this.$store.state;
      let obj = {
        'video_link': 'https://imgs.izhikang.com/izhikang-img/iprocess_www.min.mp4',
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级',
        'page_name': '课程体系在线1对1'
      }
      utils.bury('yd_izhikang_video_play', obj);
    },
    input(){
      if (phoneReg.test(this.phone)){
        this.phoneRight = true;
      } else {
        this.phoneRight = false;
      }
    },
    timer(){
      let vm = this;

      let timer = setInterval(function(){
        if (vm.codeNum == 1){
          clearInterval(timer);
          timer = null;
          vm.codeNum = 60;
          vm.reSendCode = true;
        } else {
          vm.codeNum--;
        }
      }, 1000)
    },
    send(){
      let vm = this;

      if (!this.phoneRight){
        return;
      }

      this.reSendCode = false;
      this.sendCode = false;
      this.timer();

      api.apiMethod.sendSms.post({
        phone: this.phone
      }).then(res => {
        if (res.data.code == 0){
          vm.smsContent = res.data.data;
        } else {
          vm.$store.dispatch('toast', {title: res.data.msg, show: true});
        }
      })
    },
    order(){
      let vm = this;

      if (this.isUse){
        return;
      }
      if (this.name.length == 0){

        this.$store.dispatch('toast', {title: '请填写姓名', show: true});

        return;
      }
      if (this.name.length > 10){

        this.$store.dispatch('toast', {title: '姓名不超过10字', show: true});

        return;
      }
      if (this.phone.length == 0){

        this.$store.dispatch('toast', {title: '请输入手机号码', show: true});

        return;
      }
      if (!phoneReg.test(this.phone)){
        this.$store.dispatch('toast', {title: '请输入正确的手机号码', show: true});

        return;
      }

      let obj = {
        course_type: 104,
        linkman_name: this.name,
        contact_phone: this.phone,
        grade: this.grade,
        grade_name: this.grades[this.getIndex()].grade_msg,
        subject_id: this.subject,
        subject_name: this.subjects[this.getSubjectIndex()].subject_msg,
        city: this.city.city_code,
        sms_code: this.sms_code,
        channl: 'izk_mobile'
      };
      vm.isUse = true;

      let stater = this.$store.state;
      let objGo = {
        'source_page': '首页',
        'user_tel_no': this.phone,
        'grade': this.grade,
        'subject': this.subject,
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级'
      };
      utils.bury('yd_izhikang_headpage_coursesysterm_order_confirm02', objGo);

      api.apiMethod.subscribeCourse.post(obj).then(res => {
        vm.isUse = false;
        if (res.data.code == 0){
          vm.$router.push({name: 'orderSuccess', query: {
            name: 'onlineOneToOne',
            go: 'online'
          }});
        } else {

          vm.$store.dispatch('toast', {title: res.data.msg, show: true});
        }
      })
    },
    goOrder(){
      this.$refs.order.scrollIntoView({block: 'start', behavior: 'smooth'});
      let obj = {
        'source_page': '首页课程体系【在线一对一】',
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级'
      }

      utils.bury('yd_izhikang_headpage_order_click', obj);
    },
    selectChange(){
      this.subjects = this.grades[this.getIndex()].subject;
      this.subject = this.subjects[0].subject_id;
    },
    getIndex(){
      let index = 0;

      for (let i = 0;i < this.grades.length;i++){
        if (this.grades[i].grade_id == this.grade){

          return i;
        }
      }

      return index;
    },
    getSubjectIndex(){
      let index = 0;

      for (let i = 0;i < this.subjects.length;i++){
        if (this.subjects[i].subject_id == this.subject){

          return i;
        }
      }

      return index;
    },
    getSelections(){
      let city = CityCodeData.getCityByShort(this.$route.params.city);

      let vm = this;
      let obj = {
        city_code: city.city_code
      };

      api.apiMethod.onlineData.post(obj).then(res => {
        vm.grades = res.data.content;
        vm.grade = vm.grades[0].grade_id;
        vm.subjects = vm.grades[0].subject;
        vm.subject = vm.subjects[0].subject_id;
      });
    },
    expend(num){
      this.active = num;
    },
    goOnline(){

      this.$router.push({name: 'online'})
    }
  },
  mounted(){
    this.getSelections();
    document.getElementById('client').scrollIntoView({block: 'start', behavior: 'smooth'});

    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});

    let stater = this.$store.state;
    let obj = {
      'page_name': '首页课程体系中在线一对一页面',
      'locate_city': this.city.city_name,
      'user_grade': stater.course.grade.name || '三年级'
    }
    utils.bury('yd_izhikang_page_browse', obj);
  },
  beforeDestroy(){
    this.$store.commit('isShowHeader', {isShowHeader: true});
    this.$store.commit('isShowFooter', {isShowFooter: true});
  }
}


// WEBPACK FOOTER //
// ./src/components/homePage/onlineOneToOne/OnlineOneToOne.js